export const AUTH_URL = process.env.NEXT_PUBLIC_AUTH_URL;
export const AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY = process.env.NEXT_PUBLIC_AUTH_URL_CUSTOMER_SUBSCRIPTION_KEY;
export const AUTH_URL_API_KEY = process.env.NEXT_PUBLIC_API_KEY;
export const CT_STOREKEY = process.env.NEXT_PUBLIC_CT_STOREKEY;
export const CONTACT_US = process.env.NEXT_PUBLIC_CONTACT_US;
export const SITE_URL = process.env.SITE_URL;
export const FEEDBACK_URL = process.env.NEXT_PUBLIC_FEEDBACK_URL;
export const NEXT_PUBLIC_IMAGE_CDN = process.env.NEXT_PUBLIC_IMAGE_CDN;
